<div class="auth-form">
    <form action="{{ actionUrl }}" method="post" ngNoForm>
        <input type="hidden" name="csrfmiddlewaretoken" value="{{ csrfToken }}"
           autocomplete="off">
        <div class="form-row">
            <div class="form-label form-label-thin">New Password</div>
            <div class="field-input-group input-group field-input-group-password">
                <input class="form-control field-input" placeholder="Password" id="id_password_1" type="password"
                       [(ngModel)]="form.newPassword1" name="new_password1" maxlength="50" minlength="8" required/>
                <ycn-password-reveal passwordElementId="id_password_1"></ycn-password-reveal>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label form-label-thin">Confirm New Password</div>
            <div class="field-input-group input-group field-input-group-password">
                <input class="form-control field-input"  placeholder="Password" id="id_password_2" type="password"
                       [(ngModel)]="form.newPassword2" name="new_password2" maxlength="50" minlength="8" required/>
                <ycn-password-reveal passwordElementId="id_password_2"></ycn-password-reveal>
            </div>
        </div>
        <div class="form-row">
            <div class="row form-group align-items-center">
                <div class="col">
                    <input type="submit" class="btn btn-primary" >
                </div>
                <div class="col-auto text-right">
                    <a class="text-blue" [href]="contactRedirectUrl">
                        Contact support for assistance.
                    </a>
                </div>
            </div>
        </div>
    </form>
</div>
